import { css } from '@emotion/core'
import styled from '@emotion/styled'
import {
  marketingPageMax,
  marketingMobileCuttoff,
  marketingMobilePage,
  MQ,
  lightBlue
} from '@css/constants'
import {fontSize} from "@css/styles";
import {FontNormal} from "@css/fonts";

export const MarketingPageWrapper = styled('div')(css`
  width: 100%;
  max-width: ${marketingMobilePage};
  margin: 0 auto;
  clear: both;

  @media(min-width: ${marketingMobileCuttoff}) {
    max-width: ${marketingPageMax};
    background-color: white;
  }

  footer {
    /* TODO: Check the footer that is rendering content outside bounds on mobile. */
    overflow-x: hidden;
  }
`)

export const publicHeaderStyles = css`
  margin: 0 auto;
  max-width: 1000px;
  width: 90%;
  box-sizing: border-box;
  padding: 4px 5px;

  ${MQ.SMALL_SCREENS} {
    margin: 0;
    width: 100%;
  }
`

export const MarketingPageContent = styled('div')(css`
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 100px;

  p, h3, li {
    padding-bottom: 15px;
    ${fontSize(16)};
    ${FontNormal(400)};

    a {
      color: ${lightBlue};
    }
  }
`)

export const Underline = styled('span')(css`
  text-decoration: underline;
`)
